/**
 * Generic scroll reveal, shared by the MJ x sections.
 *
 * Wrap content in <rana-reveal>; any descendant marked [data-rana-reveal] is
 * indexed so CSS can stagger it. The element adds .is-visible once in view,
 * and immediately when motion is reduced or IntersectionObserver is missing.
 */
class RanaReveal extends HTMLElement {
  connectedCallback() {
    // Marks that the script is running. The CSS only hides content once this
    // class is present, so a script that never loads cannot leave a section
    // blank — it simply renders without the animation.
    this.classList.add('is-ready');

    this.querySelectorAll('[data-rana-reveal]').forEach((el, i) => {
      el.style.setProperty('--rana-reveal-index', String(i));
    });

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.classList.add('is-visible');
          this.observer?.disconnect();
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.01 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('rana-reveal')) {
  customElements.define('rana-reveal', RanaReveal);
}
